import IngredientsZone from 'components/Catalog/ProductGrid/CompareModal/Zones/IngredientsZone/IngredientsZone';

export default IngredientsZone;
